import { useState, useEffect } from "react";
const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};

const getWidth = (width) => {
  const values = Object.values(breakpoints);
  const keys = Object.keys(breakpoints);
  for (let i = 0; i < values.length - 1; i++)
    if (width >= values[i] && width < values[i + 1]) return keys[i];
  return "xl";
};
const withWidth = (Component) => (props) => {
  const [width, setWidth] = useState(getWidth(window.innerWidth));
  useEffect(() => {
    const handleResize = () => {
      setWidth(getWidth(window.innerWidth));
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return <Component {...props} width={width} />;
};

export default withWidth;
